import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

/**
 * StatsBanner Component
 *
 * Displays key statistics in a highlighted banner
 *
 * @param {Object} props
 * @param {Object} props.stats - Object containing contributionLimit, taxTreatment, planTypeValue
 */
const StatsBanner = ({ stats }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Only render if at least one stat exists
  const hasStats = stats && (
    stats.contributionLimit ||
    stats.taxTreatment ||
    stats.planTypeValue
  );

  if (!hasStats) return null;

  const statItems = [
    {
      label: 'Contribution Limit',
      value: stats.contributionLimit,
      show: !!stats.contributionLimit
    },
    {
      label: 'Tax Treatment',
      value: stats.taxTreatment,
      show: !!stats.taxTreatment
    },
    {
      label: 'Plan Type',
      value: stats.planTypeValue,
      show: !!stats.planTypeValue
    }
  ].filter(item => item.show);

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(9, 120, 214, 0.08)',
        borderRadius: '12px',
        padding: isMobile ? '24px 16px' : '32px 40px',
        marginBottom: '32px',
        border: '1px solid rgba(9, 120, 214, 0.15)'
      }}
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : `repeat(${statItems.length}, 1fr)`,
          gap: isMobile ? '24px' : '40px'
        }}
      >
        {statItems.map((stat, index) => (
          <Box
            key={index}
            sx={{
              textAlign: isMobile ? 'left' : 'center',
              paddingBottom: isMobile && index < statItems.length - 1 ? '24px' : 0,
              borderBottom: isMobile && index < statItems.length - 1
                ? '1px solid rgba(9, 120, 214, 0.15)'
                : 'none'
            }}
          >
            <Typography
              sx={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '11px',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '1px',
                color: '#64748b',
                marginBottom: '8px'
              }}
            >
              {stat.label}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Fraunces, serif',
                fontSize: stat.value.length > 20
                  ? { xs: '18px', md: '22px' }
                  : { xs: '28px', md: '32px' },
                fontWeight: 700,
                color: '#0f172a',
                lineHeight: 1.2
              }}
            >
              {stat.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StatsBanner;
